export default "<div class=\"custom-content\">\n    {{html content}}\n</div>";